import { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { FaCheckCircle } from "react-icons/fa";
import Swal from "sweetalert2";
import franchiseAdminAPI from "../../api/franchiseAdminAPI";
import usersApi from "../../api/userApi";

const Profile = () => {
  const localUser = JSON.parse(localStorage.getItem("user"));
  const [userDetails, setUserDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [franchiseDetails, setFranchiseDetails] = useState(null);
  useEffect(() => {
    const fetchDetails = async () => {
      try {
        if (localUser?.userEmail) {
          const userResponse = await usersApi.getUserDetails(
            localUser.userEmail,
          );
          const userData = userResponse.data;

          setUserDetails(userData);

          // Fetch franchise details using referral code
          if (userData?.referralCode) {
            const franchiseResponse =
              await franchiseAdminAPI.getFranchiseDetailsByReferralCode(
                userData.referralCode,
              );

            setFranchiseDetails(franchiseResponse.data);
          }
        }
      } catch (error) {
        console.error("Failed to fetch details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDetails();
  }, [localUser?.userEmail]);

  const handleComingSoon = () => {
    Swal.fire({
      icon: "info",
      title: "Coming Soon!",
      text: "This feature is under development.",
      confirmButtonText: "OK",
    });
  };

  const user = userDetails || localUser;

  if (loading) {
    return <p>Loading profile...</p>;
  }

  return (
    <div>
      <h1>
        <strong>My Profile</strong>
      </h1>

      <Card className="p-4 mt-3">
        <Row>
          <Col md={6}>
            <h5>
              <strong>Personal Information</strong>
            </h5>
            <p>
              <strong>Name:</strong> {user?.userName}
            </p>
            <p style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <strong>Email:</strong> {user?.userEmail}
              {user?.emailVerified && (
                <FaCheckCircle color="green" title="Email Verified" />
              )}
            </p>
            <p>
              <strong>Phone:</strong> {user?.phone || "N/A"}
            </p>

            {user?.referralCode && (
              <p>
                <strong>Referral Code:</strong> {user.referralCode}
              </p>
            )}
            {user?.countryName && (
              <p>
                <strong>Country Name:</strong> {user.countryName}
              </p>
            )}
            {franchiseDetails && (
              <>
                <hr />
                <h5>
                  <strong>Franchise Information</strong>
                </h5>

                <p>
                  <strong>Franchise:</strong> {franchiseDetails.organization}
                </p>

                <p>
                  <strong>Location:</strong> {franchiseDetails.location}
                </p>

                <p>
                  <strong>Email:</strong> {franchiseDetails.email}
                </p>
              </>
            )}
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default Profile;
